import HeroSection from '../components/HeroSection';
import BrandPillars from '../components/BrandPillars';
import GroupOverview from '../components/GroupOverview';
import HistorySection from '../components/HistorySection';
import ChairmanMessage from '../components/ChairmanMessage';
import CSRSection from '../components/CSRSection';
import AwardsSection from '../components/AwardsSection';
import AboutSection from '../components/AboutSection';
import OurPresence from '../components/OurPresence';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col" >
      <main className="flex-grow overflow-x-hidden">
        <HeroSection />
        <BrandPillars />
        <HistorySection />
        <ChairmanMessage />
        <GroupOverview />
        <AboutSection />
        <OurPresence />
      </main>
    </div>
  );
};

export default Home;
